import request from '../utils/request';

// 团队注册列表
export function getteamList() {
  return request({
    url: '/frontAudience/info/groupRegistrationList',
    method: 'GET',
  });
}

// 团队注册添加成员
export function addteamuser(data) {
    return request({
      url: '/frontAudience/info/appendAudience',
      method: 'post',
      data: data,
    });
  }
  
  // 团队注册获取成员信息单条
  export function getOnedata(data) {
    return request({
      url: '/frontAudience/info/getEditAudience',
      method: 'get',
      params: data,
    });
  }
  
  // 团队注册编辑成员保存
  export function editItem(data) {
    return request({
      url: '/frontAudience/info/saveEditAudience',
      method: 'post',
      data: data,
    });
  }
  
  // 团队注册删除成员
  export function dleteItem(data) {
    return request({
      url: '/frontAudience/info/deleteAudience',
      method: 'get',
      params: data,
    });
  }
  
  // 团队注册提交
  export function uploadItem(data) {
    return request({
      url: '/frontAudience/info/commitAudience',
      method: 'post',
      data: data,
    });
  }